import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { getTimezoneId, getTZOffset } from 'utils/dateUtils'
import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { selectActualCompanyId } from 'containers/App/selectors'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { DATE_FILTER_CHANGE, SCANBACK_CHANGE } from '../constants'
import { INVESTIGATION_FILTERS_BY_VALUE } from '../EmailOverview/constants'
import { selectDateFilter, selectDateRange, selectWithoutScanback } from '../selectors'

import { phishingWidgetRedux } from './redux'

const getPhishingWidgetEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      phishingWidgetRedux.INITIATE,
      DATE_FILTER_CHANGE,
      SCANBACK_CHANGE
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    })
    .switchMap(() => {
      const state = store.getState()
      const selectedCompany = state.partnerOptions.selectedCompany?.value
      const feDateRange = selectDateRange(state)
      const dateFilter = selectDateFilter(state)
      const withoutScanback = selectWithoutScanback(state)
      const companyIds = selectActualCompanyId(state)

      const baseParams = {
        custom_dates: Array.isArray(dateFilter),
        pageSize: 10000,
        pageNumber: 1,
        emailDateRange: feDateRange,
        withoutScanback,
        company_ids: [companyIds],
        ...INVESTIGATION_FILTERS_BY_VALUE.PHISHING,
        has_incident: true,
        logDateRange: null,
        // TODO: we should handle this differently since those values can be changed
        classification: ['Unclassified', 'Phishing'],
      }

      const queryTypes = ['phish_data', 'user_count']

      const paramsForPhishData = {
        offset: getTZOffset(),
        timezone: getTimezoneId(),
      }

      return Observable.zip(
        ...queryTypes.map((queryType) =>
          api.dashboard.getPhishingWidget(selectedCompany, {
            ...baseParams,
            queryType,
            ...(queryType === 'phish_data' ? paramsForPhishData : {}),
          })
        )
      )
        .map((responses) => {
          const combinedResponse = responses.reduce(
            (acc, response) => ({ ...acc, ...response.response }),
            {}
          )
          return phishingWidgetRedux.onSuccess(combinedResponse)
        })
        .catch((error) => Observable.of(epicsErrorHandler(phishingWidgetRedux.onError, error)))
        .takeUntil(action$.ofType(phishingWidgetRedux.CANCEL, phishingWidgetRedux.ERROR))
    })

export default combineEpics(getPhishingWidgetEpic)
